/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */
import React, { Fragment } from "react";

const CardsSimpleImage = (props) => {

    const image = props.image;

    const width = 48;
    const height = 48;
    const image_style = {};
    const alt = "alt is not defined";

    return (
        <Fragment>
            {image &&
                <div className='cards-simple-image' style={image_style}>
                    <img alt={alt}
                         width={width}
                         height={height}
                         src={image.url}
                    />
                </div>
            }
        </Fragment>
    );
};

CardsSimpleImage.displayName = "CardsSimpleImage";
export { CardsSimpleImage };
